import {Pipe, PipeTransform} from '@angular/core';
import {EventDetailsType} from '../../domain/event/event';
import {ReservationDetailDto} from '../../domain/reservation/reservationDto';
import {OtpSessionDto} from '../../domain/otp/otp';

@Pipe({
    name: 'asOtpSession'
})
export class OtpSessionPipe implements PipeTransform {

    constructor() {
    }

    transform(event: EventDetailsType): OtpSessionDto {
        return event as OtpSessionDto;
    }
}
